<div class="container-fluid select-none">
  <!-- Skeleton Loader for Cards -->
  <div class="row" *ngIf="loading">
    <div *ngFor="let item of [1,2,3,4,5,6,7,8]" class="col-lg-3 col-md-4 col-sm-6 col-12 p-2">
      <div class="card kg-custom-card p-3">
        <!-- ID Badge Skeleton -->
        <p-skeleton width="3rem" height="1.2rem" borderRadius="15px" styleClass="mb-2"></p-skeleton>

        <!-- Header Skeleton (Avatar + Info) -->
        <div class="kg-card-header d-flex flex-row flex-nowrap align-items-start gap-2 w-100">
          <p-skeleton shape="circle" size="48px"></p-skeleton>
          <div class="kg-meta-container flex-grow-1 text-start">
            <p-skeleton width="55%" height="0.8rem" borderRadius="4px" styleClass="mb-2"></p-skeleton>
            <p-skeleton width="80%" height="1rem" borderRadius="4px"></p-skeleton>
          </div>
        </div>

        <!-- Footer Skeleton -->
        <div class="kg-card-footer-desktop d-none d-lg-flex justify-content-between align-items-center mt-auto w-100 pt-3">
          <p-skeleton shape="circle" size="32px"></p-skeleton>
          <p-skeleton width="5.5rem" height="1.5rem" borderRadius="20px"></p-skeleton>
        </div>
      </div>
    </div>
  </div>

  <!-- Main Cards Grid -->
  <div class="row" *ngIf="!loading">
    <div *ngFor="let item of filterItems" [ngClass]="item.expanded ? 'col-12 p-2' : 'col-lg-3 col-md-4 col-sm-6 col-12 p-2'"
      [hidden]="!checkDataCountValues(item)">
      
      <!-- COLLAPSED CARD UI -->
      <div *ngIf="!item.expanded" class="card kg-custom-card" (click)="onCardClick(item)">
        <!-- ID Badge at Top-Left -->
        <span class="kg-id-badge">{{ item.id }}</span>
        
        <!-- Card Header: Department Logo and Category Info -->
        <div class="kg-card-header d-flex flex-row flex-nowrap align-items-start gap-2 w-100">
          
          <div class="kg-avatar-container">
            <ng-container *ngIf="item.image">
              <img *ngIf="checkisImg(item.image); else parentelseBlock" src="{{ siteUrl }}{{ item.image }}" class="kg-avatar-img" />
              <ng-template #parentelseBlock>
                <i class="{{ item.image }} kg-avatar-icon"></i>
              </ng-template>
            </ng-container>
          </div>

          <div class="kg-meta-container flex-grow-1 text-start">
            <div class="kg-category-line d-flex align-items-center justify-content-start gap-1 mb-1">
              <span class="kg-category-text" [innerHTML]="object.name | highlight : filterText"></span>
            </div>
            
            <h4 class="kg-item-title m-0 rgb-title" [innerHTML]="item.name | highlight : filterText"></h4>
          </div>
          
        </div>
        
        <!-- Desktop Footer Section (Desktop only >= 992px) -->
        <div class="kg-card-footer-desktop d-none d-lg-flex justify-content-between align-items-center mt-auto w-100">
          <div class="kg-footer-actions">
            <button class="kg-bookmark-btn default-show-item" (click)="$event.stopPropagation()">
              <i class="pi pi-bookmark"></i>
            </button>
            
            <button class="kg-details-eye-btn hover-show-item" *ngIf="gotoLink != 'data'" [routerLink]="gotoLink" [queryParams]="{ id: item.id, type: datatype }" (click)="$event.stopPropagation()">
              <i class="pi pi-eye"></i>
            </button>
            <button class="kg-details-eye-btn hover-show-item" *ngIf="gotoLink == 'data'" [routerLink]="'/data/' + item.id" (click)="$event.stopPropagation()">
              <i class="pi pi-eye"></i>
            </button>
          </div>

          <div class="kg-stats-container hover-show-item" *ngIf="getCardCounters(item) && getCardCounters(item).length > 0">
            <div class="kg-stats-capsule d-inline-flex align-items-center gap-4">
              <div *ngFor="let counter of getCardCounters(item); let i = index" class="kg-stat-item d-flex align-items-center gap-1" [pTooltip]="counter.label">
                <i class="{{ counter.icon }}"></i>
                <span>{{ counter.count }}</span>
              </div>
            </div>
          </div>
        </div>
        
        <!-- Mobile Footer Actions (Visible on Mobile only < 992px) -->
        <div class="kg-card-footer-mobile d-flex d-lg-none align-items-center mt-auto w-100">
          <button class="kg-bookmark-btn" (click)="$event.stopPropagation()">
            <i class="pi pi-bookmark"></i>
          </button>
          
          <div class="flex-grow-1 d-flex justify-content-center">
            <button class="kg-chevron-toggle-btn" (click)="$event.stopPropagation(); item.showBadges = !item.showBadges">
              <i [class]="item.showBadges ? 'pi pi-chevron-up' : 'pi pi-chevron-down'"></i>
            </button>
          </div>
        </div>
        
        <!-- Mobile Collapsible Badges Content (Visible on Mobile < 992px when showBadges is true) -->
        <div class="kg-mobile-expanded-content d-lg-none w-100 mt-2" *ngIf="item.showBadges">
          <div class="kg-mobile-stats-grid d-flex flex-row justify-content-between gap-2 mt-2 w-100" *ngIf="getCardCounters(item) && getCardCounters(item).length > 0">
            <div *ngFor="let counter of getCardCounters(item); let i = index" class="kg-mobile-stat-card flex-grow-1 flex-basis-0 text-center p-2">
              <div class="kg-mobile-stat-header d-flex align-items-center justify-content-center gap-1 mb-1">
                <i class="{{ counter.icon }}"></i>
                <span class="kg-mobile-stat-count">{{ counter.count }}</span>
              </div>
              <span class="kg-mobile-stat-label d-block">{{ counter.label }}</span>
            </div>
          </div>
          
          <!-- Details button for Mobile expanded state -->
          <button class="kg-mobile-details-btn w-100 mt-3 d-flex align-items-center justify-content-center gap-2" *ngIf="gotoLink != 'data'" [routerLink]="gotoLink" [queryParams]="{ id: item.id, type: datatype }" (click)="$event.stopPropagation()">
            <i class="pi pi-eye"></i>
            <span>{{ "the details" | translator }}</span>
          </button>
          <button class="kg-mobile-details-btn w-100 mt-3 d-flex align-items-center justify-content-center gap-2" *ngIf="gotoLink == 'data'" [routerLink]="'/data/' + item.id" (click)="$event.stopPropagation()">
            <i class="pi pi-eye"></i>
            <span>{{ "the details" | translator }}</span>
          </button>
        </div>
      </div>

      <!-- EXPANDED CARD UI (Matching reference screenshot) -->
      <div *ngIf="item.expanded" class="card kg-custom-card kg-expanded-card position-relative p-4">
        <!-- Close Button (X icon on top-left corner in RTL) -->
        <button class="kg-close-btn" (click)="$event.stopPropagation(); item.expanded = false" pTooltip="إغلاق">
          <i class="pi pi-times"></i>
        </button>

        <div class="row align-items-center justify-content-between g-4 w-100 m-0">
          
          <!-- Right Side (in RTL): Badge, Avatar, Category title, Item name, Bookmark, and Details Button -->
          <div class="col-lg-5 col-12 d-flex flex-column align-items-start text-start p-0">
            
            <!-- Top ID Badge (249) -->
            <span class="kg-id-badge-expanded mb-2">{{ item.id }}</span>

            <!-- Avatar + Meta Title Header -->
            <div class="d-flex align-items-center gap-3 mb-3 w-100">
              <div class="kg-avatar-container">
                <ng-container *ngIf="item.image">
                  <img *ngIf="checkisImg(item.image); else parentelseBlockExp" src="{{ siteUrl }}{{ item.image }}" class="kg-avatar-img" />
                  <ng-template #parentelseBlockExp>
                    <i class="{{ item.image }} kg-avatar-icon"></i>
                  </ng-template>
                </ng-container>
              </div>

              <div class="kg-meta-container flex-grow-1">
                <div class="kg-category-line d-flex align-items-center gap-1 mb-1">
                  <span class="kg-category-text" [innerHTML]="object.name | highlight : filterText"></span>
                </div>
                
                <h4 class="kg-item-title m-0" [innerHTML]="item.name | highlight : filterText"></h4>
              </div>
            </div>

            <!-- Bookmark icon -->
            <div class="mb-3">
              <button class="kg-bookmark-btn" (click)="$event.stopPropagation()">
                <i class="pi pi-bookmark"></i>
              </button>
            </div>

            <!-- "عرض التفاصيل" (View Details) Button with Purple Border and Eye Icon -->
            <button class="kg-details-full-btn d-flex align-items-center justify-content-center gap-2 w-100"
              *ngIf="gotoLink != 'data'" [routerLink]="gotoLink" [queryParams]="{ id: item.id, type: datatype }">
              <i class="pi pi-eye"></i>
              <span>{{ "the details" | translator }}</span>
            </button>
            <button class="kg-details-full-btn d-flex align-items-center justify-content-center gap-2 w-100"
              *ngIf="gotoLink == 'data'" [routerLink]="'/data/' + item.id">
              <i class="pi pi-eye"></i>
              <span>{{ "the details" | translator }}</span>
            </button>

          </div>

          <!-- Left Side (in RTL): Stat Boxes Grid -->
          <div class="col-lg-7 col-12 p-0" *ngIf="getCardCounters(item) && getCardCounters(item).length > 0">
            <div class="d-flex flex-row flex-wrap justify-content-center justify-content-lg-end gap-3 w-100">
              <div *ngFor="let counter of getCardCounters(item)" class="kg-expanded-stat-box flex-grow-1 text-center">
                <div class="kg-expanded-stat-top d-flex align-items-center justify-content-center gap-2 mb-2">
                  <span class="kg-expanded-stat-count" [ngClass]="{'green-count': counter.label === 'الخدمات'}">{{ counter.count }}</span>
                  <i class="{{ counter.icon }}"></i>
                </div>
                <div class="kg-expanded-stat-label">{{ counter.label }}</div>
              </div>
            </div>
          </div>

        </div>
      </div>

    </div>
    <div *ngIf="filterItems && filterItems.length < 1" class="w-100">
      <div class="container-fluid" style="min-height: 400px">
        <div class="container d-flex justify-content-center">
          <h5 class="la-tujad mt-5 pt-5">
            {{ "There is no data" | translator }}
            <i class="pi pi-fw pi-exclamation-triangle font-2rem mx-2"></i>
          </h5>
        </div>
      </div>
    </div>
  </div>
</div>